import { Component, OnInit } from '@angular/core';
import { Router, NavigationError } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { RuntimeConfigService } from './common/services/runtime-config/runtime-config.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: false
})
export class AppComponent implements OnInit {

  constructor(
    private router: Router,
    private titleService: Title,
    private runtimeConfigService: RuntimeConfigService
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationError) {
        console.warn('Navigation error (likely widget mode):', event.error);
      }
    });
  }

  ngOnInit() {
    this.runtimeConfigService.config$.subscribe((cfg) => {
      if (cfg.browserTabTitle) {
        this.titleService.setTitle(cfg.browserTabTitle);
      }
    });
  }
}
